"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBHousePositive = function SvgBHousePositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M138.458 40.741H22.098a2.107 2.107 0 110-4.214h116.36a2.107 2.107 0 010 4.214z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M46.136 70.651H31.385a4.847 4.847 0 01-4.84-4.84V54.686a4.847 4.847 0 014.84-4.812h7.495a2.107 2.107 0 110 4.215h-7.495a.625.625 0 00-.625.625v11.099c0 .345.28.625.625.625h14.751c.345 0 .625-.28.625-.625V51.98a2.107 2.107 0 114.215 0v13.832a4.847 4.847 0 01-4.84 4.84z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M140.958 40.741h-9.461a2.107 2.107 0 010-4.214h4.994L98.559 9.202a26.37 26.37 0 00-15.53-4.987h-7.91a2.107 2.107 0 110-4.215h7.91a30.592 30.592 0 0117.975 5.802l41.591 29.938a2.775 2.775 0 01-1.637 5.001z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M128.16 93.874h-16.472a5.493 5.493 0 01-5.486-5.486V55.205a1.194 1.194 0 00-1.194-1.187H91.746c-.316-.004-.62.12-.843.344-.224.223-.35.526-.352.843v33.183a5.493 5.493 0 01-5.486 5.486H65.172a2.107 2.107 0 110-4.215h19.893c.701-.004 1.268-.57 1.272-1.271V55.205a5.395 5.395 0 015.409-5.402h13.283a5.409 5.409 0 015.408 5.402v33.183c.004.7.571 1.267 1.272 1.271h16.451a1.23 1.23 0 001.23-1.236V38.634a2.107 2.107 0 014.214 0v49.768a5.458 5.458 0 01-5.444 5.472z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M55.247 93.874H15.454a5.458 5.458 0 01-5.444-5.451V40.741H2.725a2.725 2.725 0 01-1.552-4.917l.393-.267L42.378 5.872A30.57 30.57 0 0160.458 0a6.82 6.82 0 016.815 6.82v75.028a2.107 2.107 0 11-4.215 0V6.821a2.606 2.606 0 00-2.6-2.606 26.398 26.398 0 00-15.607 5.071L7.326 36.526h4.798c1.164 0 2.107.944 2.107 2.108V88.41a1.23 1.23 0 001.223 1.25h39.793a2.107 2.107 0 110 4.215z",
    fill: "#285"
  })));
};

var _default = SvgBHousePositive;
exports["default"] = _default;